import React, { Component } from 'react';
import PropTypes from 'prop-types';
import svgXIcon from '../images/x.svg';

class VstModal extends Component {

  constructor() {
    super();
    this.state = {
      modalWidth: '',
      modalHeight: '',
    };
    this._hideModal = this._hideModal.bind(this);
  }

  componentDidMount() {
    document.getElementById('root').setAttribute('aria-hidden', 'true');
    document.getElementById('content-right').style.overflow = 'hidden';
    this._modalScrollValues();
    window.addEventListener('resize', this._modalScrollValues);
  }

  componentWillReceiveProps() {
    setTimeout(this._modalScrollValues, 0);
  }

  componentWillUnmount() {
    document.getElementById('root').setAttribute('aria-hidden', 'false');
    document.getElementById('content-right').style.overflow = 'auto';
  }

  _modalScrollValues() {
    const rootWidth = document.getElementById('root').offsetWidth;
    const maxDocWidth = document.getElementsByClassName('vst-modalOverlay')[0].clientWidth * 0.9 - 60;
    const modalInnerWidth = Math.min(maxDocWidth, document.getElementById('modal-document-inner').offsetWidth);
    const maxDocHeight = document.getElementsByClassName('vst-modalOverlay')[0].clientHeight * 0.9 - 60;
    const modalInnerHeight = Math.min(maxDocHeight, document.getElementById('modal-document-inner').offsetHeight);
    if (rootWidth >= 500) {
      this.setState({ modalWidth: modalInnerWidth, modalHeight: modalInnerHeight });
    } else {
      this.setState({ modalWidth: modalInnerWidth, modalHeight: modalInnerHeight });
    }
  }

  _showModal() {
    // attach a listener to redirect the tab to the modal window if the user somehow gets out of the modal window
    /* jQuery('body').on('focusin','#mainPage',function() {
        this._setFocusToFirstItemInModal(jQuery('#modal'));
    }) */
    // save current focus
    // focusedElementBeforeModal = jQuery(':focus');
    // this._setFocusToFirstItemInModal(obj);
  }

  _hideModal(e, obj) {
    // remove the listener which redirects tab keys in the main content area to the modal
    // jQuery('body').off('focusin','#mainPage');
    // set focus back to element that had it before the modal was opened
    // focusedElementBeforeModal.focus();
    if (this.props.hideModal) {
      this.props.hideModal(e, obj);
    }
  }

  _setFocusToFirstItemInModal(obj) {
    // get list of all children elements in given object
    const o = obj.find('*');

    // set the focus to the first keyboard focusable item
    // TODO: fix lint error
    /* eslint-disable no-undef */
    o.filter(focusableElementsString).filter(':visible').first().focus();
    /* eslint-enable no-undef */
  }

  _setInitialFocusModal(obj) {
    // get list of all children elements in given object
    const o = obj.find('*');

    // set focus to first focusable item
    // TODO: fix lint error
    /* eslint-disable no-unused-vars, no-undef */
    const focusableItems = o.filter(focusableElementsString).filter(':visible').first().focus();
    /* eslint-enable no-unused-vars, no-undef */
  }

  /* _trapTabKey(obj, e) {

    // if tab or shift-tab pressed
    if (e.which == 9) {

        // get list of all children elements in given object
        // var o = obj.find('*');

        // get list of focusable items
        var focusableItems;
        // focusableItems = o.filter(focusableElementsString).filter(':visible')
        focusableItems = obj.querySelectorAll(focusableElementsString).filter((el)=>{
          return el.offsetParent !== null;
        });

        // get currently focused item
        var focusedItem;
        focusedItem = jQuery(':focus');
        //focusedItem = document.querySelector(":focus");

        // get the number of focusable items
        var numberOfFocusableItems;
        numberOfFocusableItems = focusableItems.length

        // get the index of the currently focused item
        var focusedItemIndex;
        focusedItemIndex = focusableItems.index(focusedItem);

        if (e.shiftKey) {
            //back tab
            // if focused on first item and user preses back-tab, go to the last focusable item
            if (focusedItemIndex == 0) {
                focusableItems.get(numberOfFocusableItems - 1).focus();
                e.preventDefault();
            }

        } else {
            //forward tab
            // if focused on the last item and user preses tab, go to the first focusable item
            if (focusedItemIndex == numberOfFocusableItems - 1) {
                focusableItems.get(0).focus();
                e.preventDefault();
            }
        }
    }

  },

  _trapEscapeKey(obj, e) {

    // if escape pressed
    if (e.which == 27) {

        // get list of all children elements in given object
        var o = obj.find('*');

        // get list of focusable items
        var cancelElement;
        cancelElement = o.filter("#cancel")

        // close the modal window
        cancelElement.click();
        e.preventDefault();
    }

  }, */

  render() {
    // TODO: fix these lint errors
    /* eslint-disable no-unused-vars */

    // jQuery formatted selector to search for focusable items
    const focusableElementsString = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]';
    // store the item that has focus before opening the modal window
    let focusedElementBeforeModal;

    /* eslint-enable no-unused-vars */

    return (
      <div>
        <div id="modal-container" className="vst-modal" onKeyDown={this._trapTabKey} aria-labelledby="modalTitle" aria-describedby="modalDescription" role="dialog">
          <div style={{ width: this.state.modalWidth, height: this.state.modalHeight }} className="modal-document" role="document">
            <div id="modal-document-inner">
              <h1 id="modal-title">{this.props.title}</h1>
              {this.props.children}
              <button onClick={this._hideModal} className="modal-close-button">
                {svgXIcon()}
                {
                  // TODO: fix these lint errors
                  /* eslint-disable no-undef */
                }
                <span className="offScreen">{i18n.t('base.close')}</span>
                { /* eslint-enable no-undef */ }
              </button>
            </div>
          </div>
        </div>
        <div onClick={this._hideModal} aria-hidden className="vst-modalOverlay" tabIndex="-1"></div>
      </div>
    );
  }
}

VstModal.propTypes = {
  hideModal: PropTypes.func,
  title: PropTypes.string,
  children: PropTypes.node
};

export default VstModal;
